<header class="feedback-display-header">
	<span class="sub-header-left">
		<h2 class="sub-header-title">{{title}}</h2>
		<ng-content select="[header-filters]"></ng-content>
	</span>

	<ng-content select="[header-menu]"></ng-content>
</header>